export const OPEN_ID = 'openid';
export const PROFILE = 'profile';
export const OFFLINE_ACCESS = 'offline_access';
export const API = process.env.REACT_APP_API_SCOPE;
